import { Component, OnInit, OnDestroy, ViewChild, Output, HostListener, ElementRef } from '@angular/core';
import { trigger, transition, query, style, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';
import { ChatApiService } from '../../services/chat-api.service';
import { StompSubscription } from '@stomp/stompjs';
import { ChatStompService } from '../../services/chat-stomp.service';
import { TourService } from '../../shared/ui/tour/tour.service';
import { findPageTour } from '../../shared/ui/tour/page-tours';
import { CommonMethodService } from '../../common/commonMethod.service';
import { UserGroupService } from '../../services/userGroup.service';
import { DataShareService } from '../../services/data-share.service';
import { AccountService } from '../../services/account.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EmployeeService } from '../../services/employee.service';
import { ToastrService } from 'ngx-toastr';
import { ToastGroupService } from '../../shared/toast-group.service';
import { NavTreeService, VwFlatNavItem } from '../../shared/nav-tree.service';
import { WHATS_NEW_KEY } from '../../shared/ui/help-panel/help-panel.component';
import { UserImageService } from '../../services/user-image.service';
import { ResidentService } from '../../services/resident.service';
import { NotificationService } from '../../services/notification.service';
import { AdministratorService } from '../../services/administrator.service';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { InactivityTimeoutService } from '../../common/inactivity-timeout.service';
import { ThemeService } from '../../services/theme.service';
import { HelperStateService } from '../../services/helperState.service';
import { MessagingService } from '../../services/messaging.service';
import { toMaterialIcon } from '../../shared/icon-map';
import { VwCommandItem } from '../../shared/ui/command-palette/command-palette.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  providers: [CommonMethodService, UserGroupService, DataShareService, AccountService, EmployeeService, ResidentService, NotificationService, AdministratorService, UserService, LoginService, ChatApiService],
  animations: [
    // A page-to-page fade+settle, not a cross-fade: only the incoming view
    // is animated (no :leave/absolute-position choreography), so it can't
    // disturb any existing page's own layout/height calculations.
    trigger('routeFade', [
      transition('* <=> *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(10px)' }),
          animate('260ms cubic-bezier(.22,1,.36,1)', style({ opacity: 1, transform: 'translateY(0)' }))
        ], { optional: true })
      ])
    ])
  ]
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @ViewChild('primaryModal1') public primaryModal1: ModalDirective;
  @ViewChild('panicModal') public panicModal: ModalDirective;
  userMenuOpen = false;
  public sidebarMinimized = false;
  public navItems = [];
  public navItemsRaw = [];
  public list = [];
  role: any;
  accountId: any;
  accountName: string;
  subscribe: Array<Subscription> = [];
  imageName: any;
  username: any;
  roleShow: string;
  qrCodeName: any;
  employeeId: any;
  residentId: any;
  name: string;
  isExpired: boolean = false;
  expTime: string = '';
  type: string;
  propertyInfo: any = {};
   panicNotificationCount: any;
   // Briefly true right after a poll finds the count has gone UP since the
   // last check — drives the bell badge's arrival pulse (see
   // getPanicNotificationCount) rather than pulsing it constantly.
   panicJustArrived = false;
   chatUnreadCount = 0;
   userMasterId: any;
    manufacturingAccountFeature: boolean = false;
    private accountConfigLoaded = false;
    // Gate user (DEVICE_ADMIN): their own record, for the header's panic button and trespasser-alert switch.
    deviceUser: any = null;
    panicDescription: string = '';
selfCheckInFeature: boolean = false;
emailNotificationFeature: boolean = false;
ocrFeature: boolean = false;
chatFeature: boolean = false;
    userImage: any;
   bindingEligible: boolean = false;
   licenseStatus: string;
   featureEnabled: boolean = false;
   helpPanelOpen: boolean = false;
   hasClientLogo: boolean = false;

  // imageName: "assets/compas-logo.png"


  constructor(private httpClient: HttpClient, private route: Router, private commonMethodService: CommonMethodService,
    private userGroupService: UserGroupService, private dataShareService: DataShareService, private accountService: AccountService,
    private employeeService: EmployeeService, private toaster: ToastrService, private residentService: ResidentService, private notificationService: NotificationService, private administratorService: AdministratorService, private userService: UserService,
    private loginService: LoginService, private inactivityTimeout: InactivityTimeoutService,
    public theme: ThemeService, private helperState: HelperStateService, private elRef: ElementRef,
    private tour: TourService, private chatApi: ChatApiService, private chatStomp: ChatStompService, private messagingService: MessagingService,
    private toastGroup: ToastGroupService, private navTree: NavTreeService, private userImageService: UserImageService) {
 
    const storedMinimized = localStorage.getItem('vw_sidebar_minimized');
    this.sidebarMinimized = storedMinimized !== null ? storedMinimized === 'true' : window.innerWidth <= 991;
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
    localStorage.setItem('vw_sidebar_minimized', String(e));
  }

  logout(): void {
    this.loginService.logout().subscribe({
      complete: () => {
        sessionStorage.clear();
        this.helperState.clearLocalCache();
        this.route.navigate(['/']);
        this.toaster.success('Logged out successfully');
      },
      error: () => {
        sessionStorage.clear();
        this.helperState.clearLocalCache();
        this.route.navigate(['/']);
        this.toaster.success('Logged out successfully');
      },
    });
    this.inactivityTimeout.stop();
  }

  changePassword(): void {
    this.route.navigate(['/home/adminstrator/change-password']);
  }

  openHelpPanel(): void {
    this.helpPanelOpen = true;
  }

  toggleUserMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.userMenuOpen = !this.userMenuOpen;
  }

  
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.userMenuOpen) {
      return;
    }
    const wrap = this.elRef.nativeElement.querySelector('.vw-header__user');
    if (wrap && !wrap.contains(event.target as Node)) {
      this.userMenuOpen = false;
    }
  }

 
  shortcutsOpen = false;
  commandPaletteOpen = false;

  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    const isTyping = !!target && (
      target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT' || target.isContentEditable
    );
    
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.commandPaletteOpen = true;
      return;
    }
    if (event.key === 'Escape') {
      if (this.commandPaletteOpen) {
        this.commandPaletteOpen = false;
      }
      if (this.shortcutsOpen) {
        this.shortcutsOpen = false;
      }
      return;
    }
    if (isTyping) {
      return;
    }
    if (event.key === '?') {
      event.preventDefault();
      this.shortcutsOpen = true;
    } else if (event.key === '/') {
      const searchInput = document.getElementById('vw-global-search-input') as HTMLInputElement | null;
      if (searchInput) {
        event.preventDefault();
        searchInput.focus();
      }
    }
  }

  // Flattens the sidebar's own navItems (parents + children) into a single
  // searchable list — same data the sidebar renders, so the palette can
  // never offer a destination this user's role/rights don't already show
  // them in the sidebar.
  get commandPaletteItems(): VwCommandItem[] {
    const out: VwCommandItem[] = [];
    for (const item of (this.navItems || []) as any[]) {
      if (item.url && !item.children) {
        out.push({ name: item.name, url: item.url, icon: this.resolveNavIcon(item.icon) });
      }
      this.collectNavChildren(item.children, item.name, out);
    }
    return out;
  }

  // Recurses into nested groups (e.g. Flagged/Blacklisted/Rejected Visitor,
  // now nested a level deeper under Visitors/Guests) so their own detail
  // pages stay reachable from the command palette instead of silently
  // dropping out once they're no longer direct children of a top-level item.
  private collectNavChildren(children: any[], groupName: string, out: VwCommandItem[]): void {
    for (const child of children || []) {
      if (child.url) {
        out.push({ name: child.name, url: child.url, icon: this.resolveNavIcon(child.icon), group: groupName });
      }
      if (child.children && child.children.length) {
        this.collectNavChildren(child.children, child.name, out);
      }
    }
  }

  private resolveNavIcon(icon: string): string {
    if (!icon) {
      return 'chevron_right';
    }
    return toMaterialIcon(icon);
  }

  // Keys the `routeFade` animation off the activated leaf route's own URL
  // segments — a plain string comparison, so it only re-fires on an actual
  // navigation (not on every change-detection pass), and doesn't need any
  // route `data: { animation: ... }` wiring on the 100+ existing routes.
  prepareRoute(outlet: RouterOutlet): string {
    if (!outlet || !outlet.isActivated || !outlet.activatedRoute) {
      return '';
    }
    return outlet.activatedRoute.snapshot.url.map(segment => segment.path).join('/');
  }

  // Three-way cycle (light -> dark -> auto -> ...) — icon/title show what
  // clicking switches TO, matching the previous binary toggle's convention.
  get themeToggleIcon(): string {
    const mode = this.theme.currentMode;
    if (mode === 'light') { return 'dark_mode'; }
    if (mode === 'dark') { return 'brightness_auto'; }
    return 'light_mode';
  }

  get themeToggleTitle(): string {
    const mode = this.theme.currentMode;
    if (mode === 'light') { return 'Switch to dark mode'; }
    if (mode === 'dark') { return 'Switch to auto (follow system)'; }
    return 'Switch to light mode';
  }

  // A small toast for Device Admin screens — "X has come to visit Y" — fired
  // right after a guest checks in. The backend only ever sends this push to
  // Device Admin FCM tokens for this account (see
  // GuestService.notifyDeviceAdminsOfCheckIn), so no role check is needed
  // here; this subscription is simply inert for every other role.
  private listenForCheckInNotifications(): void {
    this.subscribe.push(this.messagingService.currentMessage.subscribe((payload: any) => {
      if (!payload || !payload.data || payload.data.type !== 'GUEST_CHECKIN_DEVICE') {
        return;
      }
      const message = (payload.notification && payload.notification.body) || 'A visitor has checked in.';
      this.toastGroup.notify(this.toaster, message, 'Visitor arrived', 'guest-checkin');
    }));
  }

  ngOnInit() {
    this.inactivityTimeout.start();
    this.listenForCheckInNotifications();

    const token = sessionStorage.getItem('token');
    const username = sessionStorage.getItem('username');
    const role = sessionStorage.getItem('role');
    const accountId = sessionStorage.getItem('accountId');
    
    if (!token || !username || !role || 
        token === 'undefined' || token === 'null' ||
        username === 'undefined' || username === 'null' ||
        role === 'undefined' || role === 'null') {
      this.route.navigate(['/login']);
      return;
    }

    if (role !== 'SUPER_ADMIN' && (!accountId || accountId === 'undefined' || accountId === 'null')) {
      this.route.navigate(['/login']);
      return;
    }

    this.subscribe.push(this.helperState.load().subscribe({
      error: () => { /* non-critical: onboarding helpers just stay unavailable this session */ },
    }));

    this.role = sessionStorage.getItem('role');
    this.type = sessionStorage.getItem('type');
    if (this.role === 'SUPER_ADMIN') {
      this.roleShow = 'SUPER_OWNER';
    } else if (this.role === 'ACCOUNT_ADMIN') {
      this.roleShow = 'ACCOUNT_SUPER_ADMIN';
    } else {
      this.roleShow = this.role;
    }
    this.accountName = sessionStorage.getItem('accountName');
    this.employeeId = sessionStorage.getItem('employeeId');
    this.accountId = sessionStorage.getItem('accountId');
    this.username = sessionStorage.getItem('username');
    this.residentId = sessionStorage.getItem('residentId');
    this.userMasterId = sessionStorage.getItem('userMasterId');
    this.bindingEligible = sessionStorage.getItem('bindingEligible') === 'true';
    this.licenseStatus = sessionStorage.getItem('licenseStatus') || 'VALID';
    this.loadUserImage();
    this.subscribe.push(this.userImageService.image$.subscribe(img => {
      if (img) {
        this.userImage = img;
      }
    }));
    try {
      const raw = localStorage.getItem(this.recentPagesKey());
      this.recentPages = raw ? JSON.parse(raw) : [];
    } catch (e) {
      this.recentPages = [];
    }
    if (this.role !== 'SUPER_ADMIN') {
      this.getAccountConfiguration();
    }
    if (this.role === 'SUPER_ADMIN' || this.role === 'RESIDENT_ADMIN' || this.role === 'EMPLOYEE_ADMIN' || this.role === 'FAMILY') {

      this.httpClient.get('assets/roleModel/superadmin.json').subscribe(data => {
        this.list = JSON.parse(JSON.stringify(data));
        this.list.forEach(x => {
          if (x.role === this.role) {
            if (this.role === 'SUPER_ADMIN' && this.username !== 'superowner') {
              x.allowActions.forEach((item) => {
                if (item.children !== undefined) {
                  item.children.forEach((subItem, index) => {
                    if (subItem.name === 'Superowner Request Details') {
                      return item.children.splice(index, 1);
                    }
                  });
                }
              });
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            } else {
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            }
          }
        });
        this.applyAllFeatureFilters();
        // console.log(data);
      });
      this.loadBindingFeatureFlag();
    } else if (this.role === 'DEVICE_ADMIN') {
      if (this.type === 'RESIDENTIAL') {
        this.httpClient.get('assets/roleModel/superadmin.json').subscribe(data => {
          this.list = JSON.parse(JSON.stringify(data));
          this.list.forEach(x => {
            if (x.role === 'DEVICE_ADMIN_R') {
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            }
          });
          this.applyAllFeatureFilters();
        });
      } else {
        this.httpClient.get('assets/roleModel/superadmin.json').subscribe(data => {
          this.list = JSON.parse(JSON.stringify(data));
          this.list.forEach(x => {
            if (x.role === 'DEVICE_ADMIN_C') {
              // Keep the full menu; whether Service Provider or Contractors (+ Vehicle Management) applies depends on the
              // account's manufacturing setting, which arrives from a separate request - see applyAllFeatureFilters().
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            }
          });
          this.applyAllFeatureFilters();
        });
      }
      this.loadBindingFeatureFlag();
    } else {
      const username = sessionStorage.getItem('username');
      if (!username) {
        if (this.route) {
          this.route.navigate(['/login']);
        }
        return;
      }
      this.subscribe.push(this.userGroupService.getUsersRights(username).subscribe(
        data => {
          const wrapper = JSON.parse(JSON.stringify(data));
          this.navItems = wrapper[0].allowActions;
          this.navItemsRaw = JSON.parse(JSON.stringify(wrapper[0].allowActions));
          this.dataShareService.setValue(this.navItems);
          this.applyAllFeatureFilters();
        }, error => {
          this.commonMethodService.returnErrorMessage(error);
        }));
      
      this.loadBindingFeatureFlag();
    }
    if (this.accountId !== '' && this.accountId !== undefined && this.accountId !== null) {
      this.getAccountImage('');
    } else {
      this.imageName = 'assets/Icon-196.png';
    }

    // if(this.role==='EMPLOYEE_ADMIN'){
    //   this.checkStaffQRExpire();
    // }
    if (this.role === 'WEB_ADMIN' || this.role === 'ACCOUNT_ADMIN') {
      this.pollPanicNotificationCount();
    }
    if (this.role === 'DEVICE_ADMIN') {
      this.pollInfoNotifications();
      this.loadDeviceUser();
    }

    // pollChatUnreadCount() is started from getAccountConfiguration() above, once
    // chatFeature is known - not unconditionally, since a disabled account shouldn't
    // poll a chat endpoint it can't use.
    this.setUpPageTours();
  }

  private setUpPageTours(): void {
    this.subscribe.push(this.helperState.loaded$.subscribe(loaded => {
      if (loaded) {
        this.tryStartTourFor(this.route.url);
        if (!this.helperState.isDismissed(WHATS_NEW_KEY)) {
          this.helpPanelOpen = true;
        }
      }
    }));
    this.subscribe.push(this.route.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      if (this.helperState.isLoaded()) {
        this.tryStartTourFor(e.urlAfterRedirects);
      }
      this.recordRecentPage(e.urlAfterRedirects);
    }));
  }

  // "Recently viewed" for the command palette — separate from search history,
  // this tracks actual navigations. Matched against the already-flattened
  // commandPaletteItems rather than storing raw URLs, so it always shows a
  // friendly name the user recognizes instead of a path.
  recentPages: VwFlatNavItem[] = [];

  private recentPagesKey(): string {
    return 'vw-recent-pages:' + (this.username || 'global');
  }

  private recordRecentPage(url: string): void {
    const match = this.commandPaletteItems.find(i => i.url && url.indexOf(i.url) === 0);
    if (!match) {
      return;
    }
    let stored: VwFlatNavItem[];
    try {
      const raw = localStorage.getItem(this.recentPagesKey());
      stored = raw ? JSON.parse(raw) : [];
    } catch (e) {
      stored = [];
    }
    const entry: VwFlatNavItem = { name: match.name, url: match.url, icon: match.icon };
    stored = [entry].concat(stored.filter(p => p.url !== match.url)).slice(0, 8);
    try {
      localStorage.setItem(this.recentPagesKey(), JSON.stringify(stored));
    } catch (e) {
      // localStorage unavailable — recent pages just won't persist this session
    }
    this.recentPages = stored;
  }

  private tryStartTourFor(url: string): void {
    // Superowner runs a cross-property console with its own conventions —
    // no guided tour is authored for that role.
    if (this.role === 'SUPER_ADMIN') {
      return;
    }
    // Tours only auto-play for genuinely new accounts, during their first
    // session — anyone with prior helper-state history (i.e. an existing
    // user encountering a page/tour for the first time, not just a brand
    // new signup) has to open Help & Resources and replay a tour on
    // purpose. See HelperStateService.isFirstVisit for what sets this.
    if (!this.helperState.isFirstVisit()) {
      return;
    }
    const entry = findPageTour(url);
    if (entry && !this.helperState.isDismissed(entry.key)) {
      setTimeout(() => this.tour.start(entry.steps, entry.key), 800);
    }
  }

  // The backend re-reads the image file from disk and re-encodes it to
  // base64 on every single call (Base64ToKeyUtility.convertImageToBase64 —
  // no caching, no HTTP cache headers on this JSON response) — on a
  // deployed server with slower disk I/O than localhost, that's real,
  // avoidable latency on a request that fires on every page load. Cached
  // client-side per filename for the session, same pattern already used for
  // the login success overlay's account image.
  loadUserImage(): void {
    const userImageName = sessionStorage.getItem('userImage');
    if (userImageName === undefined || userImageName === null || userImageName === '') {
      return;
    }
    let cached: string | null = null;
    try {
      cached = sessionStorage.getItem('vw-user-image:' + userImageName);
    } catch {
      cached = null;
    }
    if (cached) {
      this.userImage = cached;
      return;
    }
    this.subscribe.push(this.userService.getImageBase64(userImageName).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        if (wrapper.imageBase64 !== undefined && wrapper.imageBase64 !== null && wrapper.imageBase64 !== '') {
          const dataUrl = 'data:image/jpg;base64,' + wrapper.imageBase64;
          this.userImage = dataUrl;
          try {
            sessionStorage.setItem('vw-user-image:' + userImageName, dataUrl);
          } catch {
            // sessionStorage unavailable (private mode, quota, etc.) — skip silently
          }
        }
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

   getAccountConfiguration(): void {
    this.subscribe.push(this.administratorService.getAccountConfiguration(this.accountId).subscribe(
      data => {
        this.accountConfigLoaded = true;
        const wrapper = JSON.parse(JSON.stringify(data));
        wrapper.forEach(element => {
          if (element.featureId === 10) {
            this.manufacturingAccountFeature = element.value === 'true' ? true : false;
          }
          if (element.featureId === 14) {
            this.selfCheckInFeature = element.value === 'true' ? true : false;
          }
          if (element.featureId === 15) {
            this.emailNotificationFeature = element.value === 'true' ? true : false;
            this.dataShareService.emailNotificationFeature = this.emailNotificationFeature;
          }
          if (element.featureId === 17) {
            this.ocrFeature = element.value === 'true' ? true : false;
          }
          // looked up by code, not a fixed id - chat was added after the id scheme above
          // was already in place, and the backend supports code-based lookup either way.
          if (element.featureCode === 'chat') {
            this.chatFeature = element.value === 'true' ? true : false;
            this.dataShareService.chatFeature = this.chatFeature;
          }
        });
        this.applyAllFeatureFilters();
        if (this.chatFeature) {
          this.pollChatUnreadCount();
          this.keepChatSessionOpen();
        }
      }, error => {
        // Settings unavailable: show the menu with the defaults rather than no menu at all.
        this.accountConfigLoaded = true;
        this.applyAllFeatureFilters();
        this.commonMethodService.returnErrorMessage(error);
      }
    ));
  }
  getAccountImage(value): void {
    this.subscribe.push(this.accountService.findAccountById(this.accountId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        if (wrapper.imageB64 === undefined || wrapper.imageB64 === '' || wrapper.imageB64 === null) {
          this.imageName = 'assets/Icon-196.png';
          this.hasClientLogo = false;
        } else {
          // const image = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + wrapper.imageName);
          this.imageName = wrapper.imageB64;
          this.hasClientLogo = true;
        }
        this.propertyInfo = wrapper;
        if (value === 'property') {
          this.primaryModal1.show();
        }
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));

  }

  getPropertyInfo(): void {
    this.getAccountImage('property');
  }

  regenerateQRCode(): void {
    this.subscribe.push(this.employeeService.regenerateQRCode(this.employeeId).subscribe(
      data => {
        this.toaster.success('QR code re-generated successfully');
        this.isExpired = false;
        this.primaryModal.hide();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  regenerateResidentQRCode(): void {
    this.subscribe.push(this.residentService.regenerateQRCode(this.residentId).subscribe(
      data => {
        this.toaster.success('QR code re-generated successfully');
        this.isExpired = false;
        this.primaryModal.hide();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  checkStaffQRExpire(): void {
    this.subscribe.push(this.employeeService.checkStaffQRExpire(this.employeeId, this.accountId).subscribe(
      data => {
        this.isExpired = JSON.parse(JSON.stringify(data));
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  checkResidentQRExpire(): void {
    this.subscribe.push(this.residentService.checkResidentQRExpire(this.residentId, this.accountId).subscribe(
      data => {
        this.isExpired = JSON.parse(JSON.stringify(data));
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  showStaffQRCode(): void {
    this.expTime = '';
    this.subscribe.push(this.employeeService.getStaffQRImage(this.employeeId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.qrCodeName = 'data:image/jpg;base64,' + wrapper.imageBase64;
        this.name = wrapper.name;
        this.expTime = wrapper.qrExpiryDate;
        this.checkStaffQRExpire();
        this.primaryModal.show();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  showResidentQRCode(): void {
    this.expTime = '';
    this.subscribe.push(this.residentService.getResidentQRImage(this.residentId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.qrCodeName = 'data:image/jpg;base64,' + wrapper.imageBase64;
        this.name = wrapper.name;
        this.expTime = wrapper.qrExpiryDate;
        this.checkResidentQRExpire();
        this.primaryModal.show();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  //  downloadQRCode(): void {
  //   this.subscribe.push(this.employeeService.getStaffQRImage(this.employeeId).subscribe(
  //     data => {
  //       const wrapper  = JSON.parse(JSON.stringify(data));
  //       if (wrapper.imageBase64 === undefined || wrapper.imageBase64 === '' || wrapper.imageBase64 === null) {
  //         this.toaster.error('No image found!!!');
  //       } else {
  //         var a = document.createElement("a"); //Create <a>
  //         a.href = "data:image/png;base64," + wrapper.imageBase64; //Image Base64 Goes here
  //         a.download = "QRCode.png"; //File name Here
  //         a.click(); //Downloaded file
  //       }
  //     }, error => {
  //       this.commonMethodService.returnErrorMessage(error);
  //     }));
  // }

  // downloadResidentQRCode(): void {
  //   this.subscribe.push(this.residentService.getResidentQRImage(this.residentId).subscribe(
  //     data => {
  //       const wrapper  = JSON.parse(JSON.stringify(data));
  //       if (wrapper.imageBase64 === undefined || wrapper.imageBase64 === '' || wrapper.imageBase64 === null) {
  //         this.toaster.error('No image found!!!');
  //       } else {
  //         var a = document.createElement("a"); //Create <a>
  //         a.href = "data:image/png;base64," + wrapper.imageBase64; //Image Base64 Goes here
  //         a.download = "QRCode.png"; //File name Here
  //         a.click(); //Downloaded file
  //       }
  //     }, error => {
  //       this.commonMethodService.returnErrorMessage(error);
  //     }));
  // }

  downloadQRCode(): void {
    const a = document.createElement('a');
    a.href = this.qrCodeName;
    a.download = 'QRCode.png';
    a.click();
  }

  loadImage(): string {
    if (this.imageName) {
      return this.imageName;
    }
    return this.theme.current === 'dark' ? 'assets/VOWEL12.png' : 'assets/Icon-196.png';
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
    this.chatSessionSubs.forEach(sub => sub.unsubscribe());
    // The layout only goes away on logout / session expiry, so this is the one place the session closes.
    this.chatStomp.disconnect();
  }

  private chatSessionSubs: StompSubscription[] = [];

  // Other users (and the mobile apps) see this person as online only while a WebSocket session is open.
  // It used to be opened by the Chat page and closed when leaving it, so anyone working on another page
  // looked offline. The layout now holds it open for the whole login. While it is open the server treats the
  // user as online and no longer sends a push notification, so a new message must also refresh the badge
  // here, immediately, instead of waiting for the 15s poll.
  private keepChatSessionOpen(): void {
    this.chatStomp.ensureConnected();
    this.subscribe.push(this.chatStomp.connected$.subscribe(connected => {
      this.chatSessionSubs.forEach(sub => sub.unsubscribe());
      this.chatSessionSubs = [];
      if (!connected) {
        return;
      }
      const sub = this.chatStomp.subscribe<any>('/user/queue/chat.messages', () => this.refreshChatUnreadCount());
      if (sub) {
        this.chatSessionSubs.push(sub);
      }
    }));
  }

  private refreshChatUnreadCount(): void {
    this.chatApi.getMyConversations().subscribe(
      conversations => this.chatUnreadCount = conversations.reduce((sum, c) => sum + (c.unreadCount || 0), 0),
      () => { /* a failed refresh is retried by the 15s poll */ }
    );
  }

  // Backstop poll for the header badge; live updates arrive over the shared session (keepChatSessionOpen).
  // Only called once chatFeature is confirmed true (see getAccountConfiguration) - SUPER_ADMIN
  // never reaches here either, since it manages the whole platform rather than one account.
  private pollChatUnreadCount(): void {
    this.subscribe.push(interval(15000).pipe(startWith(0)).subscribe(() => this.refreshChatUnreadCount()));
  }

  // ---- gate user: panic button and trespasser alerts (used to live on Administrator > User Details)
  private loadDeviceUser(): void {
    this.subscribe.push(this.userService.getDeviceUserDetails(sessionStorage.getItem('username')).subscribe(
      (data: any) => {
        this.deviceUser = JSON.parse(JSON.stringify(data));
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  openPanicModal(): void {
    this.panicDescription = '';
    this.panicModal.show();
  }

  submitPanic(): void {
    const description = (this.panicDescription || '').trim();
    if (!description) {
      this.toaster.error('Please enter the description.');
      return;
    }
    if (description.length > 50) {
      this.toaster.error('Description max length is 50 characters');
      return;
    }
    if (!this.deviceUser) {
      this.toaster.error('Your user details are still loading, please try again.');
      return;
    }
    const detail: any = {
      accountId: this.deviceUser.accountId || this.accountId,
      userMasterId: this.deviceUser.id,
      description,
      role: this.deviceUser.role
    };
    this.subscribe.push(this.notificationService.sendPanicNotification(detail).subscribe(
      () => {
        this.toaster.success('Panic notification successfully sent.');
        this.panicModal.hide();
      }, error => {
        this.panicModal.hide();
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  toggleTrespasserAlerts(): void {
    if (!this.deviceUser) {
      return;
    }
    const enable = !this.deviceUser.enableNotification;
    this.subscribe.push(this.userService.changeTresspasserNotification({
      accountId: this.deviceUser.accountId,
      userId: this.deviceUser.userId,
      enable
    }).subscribe(
      () => {
        this.deviceUser.enableNotification = enable;
        this.toaster.success('Trespasser notification successfully ' + (enable ? 'enabled.' : 'disabled.'));
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  // In-app notices (self check-in approved/rejected) for gate users. They live on the server for a few minutes,
  // so this works even when push (FCM) is not set up. Each one is toasted once, then marked read.
  private shownInfoNotices = new Set<number>();

  private pollInfoNotifications(): void {
    this.subscribe.push(interval(20000).pipe(startWith(0)).subscribe(() => {
      this.subscribe.push(this.notificationService.getInfoNotifications(this.accountId).subscribe(
        (list: any) => {
          const fresh = (list || []).filter((n: any) => !n.read && !this.shownInfoNotices.has(n.id));
          if (fresh.length === 0) {
            return;
          }
          fresh.forEach((n: any) => {
            this.shownInfoNotices.add(n.id);
            this.toastGroup.notify(this.toaster, (n.guestName ? n.guestName + ' - ' : '') + n.message, n.title, 'self-checkin-' + n.id);
          });
          this.subscribe.push(this.notificationService.readInfoNotifications(this.accountId).subscribe(() => { }, () => { }));
        }, () => { }));
    }));
  }

  private pollPanicNotificationCount(): void {
    this.subscribe.push(interval(20000).pipe(startWith(0)).subscribe(() => this.getPanicNotificationCount()));
  }

  getPanicNotificationCount(): void {
    this.subscribe.push(this.notificationService.getPanicNotificationCount(this.accountId, this.userMasterId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        const next = wrapper.panicNotificationCount;
        if (Number(next) > Number(this.panicNotificationCount || 0)) {
          this.panicJustArrived = true;
          setTimeout(() => { this.panicJustArrived = false; }, 1800);
        }
        this.panicNotificationCount = next;
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  changeStatusPanicNotifiaction(): void {
    this.subscribe.push(this.notificationService.changeStatusPanicNotifiaction(this.accountId, this.userMasterId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.panicNotificationCount = wrapper.panicNotificationCount
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  private removeBindingItems(navItems: any[], hideBinding: boolean): any[] {
    if (!hideBinding) {
      return navItems;
    }
    const bindingNames = ['Device Binding Management', 'Bind Mobile App'];
    const filterRecursive = (items: any[]): any[] => {
      return items.filter(item => !bindingNames.includes(item.name)).map(item => {
        if (item.children && item.children.length > 0) {
          return { ...item, children: filterRecursive(item.children) };
        }
        return item;
      });
    };
    return filterRecursive(navItems);
  }

  private loadBindingFeatureFlag(): void {
    if (!this.accountId) return;
    this.subscribe.push(this.administratorService.checkMobileBindingLicense(this.accountId).subscribe(
      data => {
        const wrapper: any = data;
        this.featureEnabled = wrapper.featureEnabled || false;
        this.applyAllFeatureFilters();
      },
      error => {
        this.featureEnabled = false;
        this.applyAllFeatureFilters();
      }
    ));
  }

  private applyAllFeatureFilters(): void {
    if (!this.navItemsRaw || this.navItemsRaw.length === 0) {
      return;
    }
    let filtered = JSON.parse(JSON.stringify(this.navItemsRaw));
    if (this.role === 'DEVICE_ADMIN' && this.type !== 'RESIDENTIAL') {
      // Commercial gate user: Contractors / Vehicle Management exist only for manufacturing accounts, Service Provider
      // only for the others. Wait for the account settings so the wrong one is never shown (or the right one dropped).
      if (!this.accountConfigLoaded) {
        return;
      }
      filtered = filtered.filter(e => this.manufacturingAccountFeature
        ? e.name !== 'Service Provider'
        : e.name !== 'Contractors' && e.name !== 'Vehicle Management');
    }
    if (!this.featureEnabled) {
      filtered = this.removeBindingItems(filtered, true);
    }
    if (!this.selfCheckInFeature) {
      filtered = this.removeSelfCheckInItems(filtered, true);
    }
    filtered = this.addDynamicReportsItem(filtered);
    this.navItems = filtered;
    this.dataShareService.setValue(this.navItems);
    this.navTree.setItems(this.navItems);
  }

  // Dynamic Report isn't seeded in the backend's rights/menu tables yet, so
  // it's added client-side for account-tier roles rather than requiring a
  // database migration for this first, small-scope pass — see the "Report"
  // group's real children (Exited Visitor/Audit Trail/Vehicle) for the
  // shape this matches.
  private addDynamicReportsItem(navItems: any[]): any[] {
    if (this.role !== 'ACCOUNT_ADMIN' && this.role !== 'WEB_ADMIN') {
      return navItems;
    }
    const reportGroup = navItems.find(item => item.name === 'Report' && item.children);
    if (!reportGroup || reportGroup.children.some(child => child.name === 'Dynamic Report')) {
      return navItems;
    }
    reportGroup.children.push({
      allowView: true,
      name: 'Dynamic Report',
      icon: 'icon-graph',
      url: '/home/report/dynamicReport',
    });
    return navItems;
  }

  private removeSelfCheckInItems(navItems: any[], hideSelfCheckIn: boolean): any[] {
    if (!hideSelfCheckIn) {
      return navItems;
    }
    const selfCheckInNames = ['Self Check In QR'];
    const filterRecursive = (items: any[]): any[] => {
      return items.filter(item => !selfCheckInNames.includes(item.name)).map(item => {
        if (item.children && item.children.length > 0) {
          return { ...item, children: filterRecursive(item.children) };
        }
        return item;
      });
    };
    return filterRecursive(navItems);
  }

  private removeOcrItems(navItems: any[], hideOcr: boolean): any[] {
    if (!hideOcr) {
      return navItems;
    }
    const ocrNames = ['OCR Key Stats'];
    const filterRecursive = (items: any[]): any[] => {
      return items.filter(item => !ocrNames.includes(item.name)).map(item => {
        if (item.children && item.children.length > 0) {
          return { ...item, children: filterRecursive(item.children) };
        }
        return item;
      });
    };
    return filterRecursive(navItems);
  }
}
